<template>
	<div>
		 <wxlogin :appid="appid" scope="snsapi_login" :theme="'black'"  :redirect_uri="redirect_uri" :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"></wxlogin>
	</div>
</template>

<script>
import wxlogin from "vue-wxlogin";
export default {
	components:{
	    wxlogin
	},
	data() {
		return {
			
		}
	}
}
</script>

<style>
</style>